export enum ColumnType {
  PRESENCE = 'presence',
  ABSENCE = 'absence',
}
